import styled from 'styled-components';

export const PromoCardContainer = styled.div`
  padding: 24px;
  background: #f6f6f6;
  overflow: hidden;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const PromoTitle = styled.h2`
  color: #222222;
  font-size: 24px;
  font-family: Poppins;
  font-weight: 700;
  line-height: 32px;
  margin: 0;
`;

export const PromoSubtitle = styled.p`
  color: #545454;
  font-size: 16px;
  font-family: Poppins;
  font-weight: 500;
  line-height: 24px;
  margin: 0;
  font-style: italic;
`;

export const PromoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PromoSectionTitle = styled.h3`
  color: #222222;
  font-size: 18px;
  font-family: Poppins;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
`;

export const PromoList = styled.ul`
  margin: 0;
  padding-left: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PromoListItem = styled.li`
  color: #545454;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 400;
  line-height: 20px;
`;

export const PromoCTA = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  padding-top: 8px;
`;

export const PromoCTAText = styled.p`
  color: #222222;
  font-size: 15px;
  font-family: Poppins;
  font-weight: 500;
  line-height: 22px;
  margin: 0;
  text-align: center;
`;
